// extracted by mini-css-extract-plugin
export default {"Text":"time-bound-filter-warning-module__Text--sLKvQ","Box":"time-bound-filter-warning-module__Box--JLNBA"};